import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { DetalhamentoMeuFaturamento } from 'src/app/models/detalhamento-meu-faturamento';
import { Usuario } from 'src/app/models/usuario-login';
import { FaturamentoService } from 'src/app/services/http/faturamento.service';
import { LoginService } from 'src/app/services/login.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-meu-faturamento',
  templateUrl: './meu-faturamento.component.html',
  styleUrls: ['./meu-faturamento.component.scss']
})
export class MeuFaturamentoComponent implements OnInit {
  tabledata: DetalhamentoMeuFaturamento[] = [];

  usuario: Usuario;
  title: any;

  first: number = 0;
  faturamento: DetalhamentoMeuFaturamento = {} as DetalhamentoMeuFaturamento;

  cols: any = [
    { field: 'mesStr', header: 'Mês' },
    { field: 'valorBoleto', header: 'Valor' },
    // { field: 'statusBoleto', header: 'Status Boleto' },
    { field: 'vencimentoStr', header: 'Vencimento' }
  ];

  mesStr = {

    '1':'01 - Janeiro',
    '2': '02 - Fevereiro',
    '3': '03 - Março',
    '4': '04 - Abril',
    '5': '05 - Maio',
    '6': '06 - Junho',
    '7': '07 - Julho',
    '8': '08 - Agosto',
    '9': '09 - Setembro',
    '10': '10 - Outubro',
    '11': '11 - Novembro',
    '12': '12 - Dezembro',
  }

  dynamicdownloadName: string = "meu_faturamento"

  disableAll: boolean = false;

  ano: number;
  idUnidade: string;

  constructor(private activedRoute: ActivatedRoute, private router: Router, private faturamentoService: FaturamentoService, private formBuilder: FormBuilder, private msgModal: ModalMsgService, private loginService: LoginService) {
    this.activedRoute.params.pipe()
    this.loginService.getLogIn().subscribe(l => this.usuario = l);
    this.ano = (new Date()).getFullYear()

  }

  ngOnInit(): void {
    if(this.usuario !=null && this.usuario != undefined && this.usuario.unidade !=null && this.usuario.unidade != undefined && this.usuario.unidade.id !=null) {
      this.idUnidade = this.usuario.unidade.uuid
     this.listarMeuFaturamento()
    }
}

  clean() {
    this.tabledata = [];
    this.disableAll = false
  }

  listarMeuFaturamento() {
    this.faturamentoService.listarMeuFaturamento(this.idUnidade, this.ano)
      .then(result => {
        this.clean();
        this.tabledata = result;
        this.tabledata.forEach(r => {
           r.mesStr = this.mesStr[r.mesFaturamento + '']
           r.vencimentoStr = this.dataFormatada(r.dataVencimentoBoleto);
           r.linkPdf = environment.wsUrl+"faturamento/pdfFaturasDetalhadoCliente/"+r.uuidFaturamento+"/"+r.uuidUnidade
           r.linkXlsx = environment.wsUrl+"faturamento/excelFaturasDetalhadoCliente/"+r.uuidFaturamento+"/"+r.uuidUnidade
        });
      })
      .catch(e => {
        this.msgModal.openDialog('Erro ao carregar as informações da unidade com id: ' + this.idUnidade,
          (e.error.error != undefined ? e.error.error : 'Verifique o problema com o suporte'), 'danger');
        console.error(e)
      });

  }

  filtrar() {
    if (this.ano !=null && this.ano != undefined && this.ano >0 ){
      this.listarMeuFaturamento()
    }else {
      this.msgModal.openDialog('Alerta', 'Informe os campos necessários!', '', 'warning');
    }
  }

  dataFormatada(dataStr: string) {

    if (dataStr != null && dataStr != undefined && dataStr != '') {
      var data = new Date(dataStr),
        dia = data.getDate().toString(),
        diaF = (dia.length == 1) ? '0' + dia : dia,
        mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
        mesF = (mes.length == 1) ? '0' + mes : mes,
        anoF = data.getFullYear(),
        hora = data.toISOString().substr(11, 8),
        horaF = parseInt(hora.split(':')[0]) - 3 + ':' + hora.split(':')[1] + ':' + hora.split(':')[2];
      return diaF + "/" + mesF + "/" + anoF + " " + horaF;
    }
    else {
      return '';
    }

  }

}
